export default "{\n    \"hiddenOptionsWarningText\": \"Not showing all options, search to filter.\"\n}\n"